module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idWinPanel",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "100%",
      "height": "100%",
      "border": "0px solid red",
      "display": "none"
    },
    attrs: {
      "id": "idWinPanel"
    },
    on: {
      "mouseout": _vm.onMouseOut
    }
  }, [_c('div', {
    ref: "idPopWinPanel",
    attrs: {
      "id": "idPopWinPanel"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42db4b2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/cf/popmenu.vue
// module id = 782
// module chunks = 1